import React from 'react';

export default function LoginButton() {
  return (
    <button
      data-test-id="login-checkout-button"
      className="btn btn-primary btn-lg btn-block checkout-button mb-2"
      type="button"
      data-login="">
      Login and Checkout
    </button>
  );
}
